import application_settings from '../applicationSettings';
import LocalStorage from '../local_data';
import Event from './Event';

class GetSettings extends Event {
    eventName = 'oms_getSettings';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get settings
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let clientSettings = new LocalStorage.ClientSettings(clientId);
        let settings = clientSettings.getData();
        let orderCurrency = localStorage.getItem('orderCurrency');
        console.log("settings orderCurrency", orderCurrency)
        if (orderCurrency && settings) { 
            // add order currency to settings data pass the order currency with data object
            const payload = {
                order_currency: orderCurrency,
                client_id: clientId
            }

            data.data = payload;
        }
        
        if(settings){
            thisObj.onSuccessEvent(thisObj.formatResponseData(settings), {'action' : action, 'request_id' : requestId });
        }
        
        data.endPoint = application_settings.endPoints.getSettings;
        console.log("data setting", data)
        this.sendRequest(data, function(response) {
            if (response) {
                //add data to storage
                let clientSettings = new LocalStorage.ClientSettings(clientId);
                clientSettings.setData(response);

                //format response data
                let data = thisObj.formatResponseData(response);
                
                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });
    }
}

export default GetSettings;